<script lang="ts">
	import { Button, ButtonType, CopyButton } from '@repo/commons/components'
	import type { MessageActionType } from '@repo/commons/models'

	interface Props {
		onclick: (action: MessageActionType) => void
		showFeedbackButtons?: boolean
	}

	let { onclick, showFeedbackButtons = true }: Props = $props()
	let clickedAction: MessageActionType | null = $state(null)
	function handleActionClick(action: MessageActionType) {
		if (clickedAction !== action) {
			clickedAction = action
			onclick(action)
		}
	}
	function getActiveCollor(value: MessageActionType) {
		if (clickedAction === value) {
			return 'text-[#077bcc]'
		}
		return 'text-[#002C4D80]'
	}
</script>

<div class="message-actions">
	<CopyButton onClick={() => onclick('COPY')} />

	{#if showFeedbackButtons}
		<Button
			buttonText=""
			buttonType={ButtonType.TERTIARY_INVERSE}
			rounded
			iconProps={{ name: 'like', size: 'md', class: getActiveCollor('POSITIVE') }}
			onclick={() => handleActionClick('POSITIVE')}
		/>
		<Button
			buttonText=""
			buttonType={ButtonType.TERTIARY_INVERSE}
			rounded
			iconProps={{ name: 'dislike', size: 'md', class: getActiveCollor('NEGATIVE') }}
			onclick={() => handleActionClick('NEGATIVE')}
		/>
	{/if}
</div>

<style lang="postcss">
	.message-actions {
		@apply flex gap-0 mt-3;
	}

	.message-actions :global(.button-class) {
		@apply px-0 !flex-none;
	}
</style>
